module.exports = {
  product_id: 5,
  template: 'hxz',
  prodKey: 'ut-dunion-kf',
  wxOauth: true,
  productType: 'kf',
  scene: 1104,
}
